// logoUrl, logoPosition,  logoWidth, logoHeight

// to use this varibale which are in the settings object, we need to show the logo on the player inn the
// create there is a <div> called player-logo-wrapper and you need to find the player-logo-wrapper and append the <image> tag to it

// you can use the below code to append the image tag to the player-logo-wrapper

export default function addLogoToPlayer (config) {
  if (config) {
    const { logoUrl, logoHyperlink, logoPosition } = config

    // Get the viewport width and height
    const viewportWidth = window.innerWidth

    // Check if the viewport is smaller than a typical desktop width (e.g., 768px for mobile)
    const isMediumViewPort = config.logoWidth > 30 && viewportWidth < 720 && viewportWidth > 320
    const isSmallViewport = config.logoWidth > 30 && viewportWidth < 320

    // Use config numbers for desktop and large viewports
    const logoWidth = isMediumViewPort ? (config.logoWidth * 0.5) : (isSmallViewport ? (config.logoWidth * 0.3) : config.logoWidth) // accordig to the viewport width for mobile
    // const logoHeight = isSmallViewport ? (viewportWidth * 0.1) : config.logoHeight // 10% of viewport width for mobile

    const playerLogoWrapper = document.querySelector('.player-logo-wrapper')
    const logo = document.createElement('img')
    logo.src = logoUrl
    logo.style.position = 'absolute'

    // Positioning logic
    logo.style.left = logoPosition.includes('left') ? '5px' : 'auto'
    logo.style.right = logoPosition.includes('right') ? '5px' : 'auto'
    logo.style.top = logoPosition.includes('top') ? '5px' : 'auto'
    logo.style.bottom = logoPosition.includes('bottom') ? '5px' : 'auto'
    // logo.style.maxWidth = isSmallViewport ? '50%' : '100%'
    // Set logo width and height
    logo.style.width = `${logoWidth}px`
    // logo.style.height = `${logoHeight}px`;
    // logo.style.backgroundSize = `${logoWidth}px auto`
    logo.style.opacity = '1'

    if (logoHyperlink) {
      const anchor = document.createElement('a')
      anchor.href = logoHyperlink
      anchor.target = '_blank'
      anchor.rel = 'noopener noreferrer'
      anchor.style.display = 'inline-block'
      // anchor.style.position = 'absolute'; // Ensures anchor is positioned just like the image
      anchor.style.left = logo.style.left
      anchor.style.right = logo.style.right
      anchor.style.top = logo.style.top
      anchor.style.bottom = logo.style.bottom

      anchor.appendChild(logo)
      playerLogoWrapper.appendChild(anchor)
    } else {
      playerLogoWrapper.appendChild(logo)
    }
  }
}
